const { tooltipClasses, Tooltip, styled } = require('@mui/material');

export const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#137dc5',
        padding: '12px',
        color: 'white',
        borderRadius: '2.5em',
    },
}));
